import axios from 'axios';
import {Store} from './app/redux/Store';
import { setPageLoading } from './app/redux/actions/DashboardActions';
import { apiPathUrl } from './app/utils/config';
import { getStoredUser } from './app/utils/localStorage';
import { clearActiveProvider, withTenantProvider } from './app/utils/tenantApi';

const jwtToken = getStoredUser();

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};
if (jwtToken) headers.Authorization = `Bearer ${jwtToken?.access_token}`;

const axiosInstance = axios.create({
  baseURL: apiPathUrl,
  // baseURL: 'https://ff95-103-152-101-133.in.ngrok.io',
  headers,
});
axiosInstance.interceptors.request.use((config) => {
  config.url = withTenantProvider(config.url);
  const currentAccessToken = window.localStorage.getItem('accessToken');
  if (currentAccessToken) {
    config.headers.Authorization = `Bearer ${currentAccessToken}`;
  } else if (config.headers) {
    delete config.headers.Authorization;
  }
  // Let browser set multipart boundary for file uploads.
  if (typeof FormData !== 'undefined' && config?.data instanceof FormData) {
    if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }
  // Set loading to true before making the request
  // Dispatch the setLoading action with true to update loading state in Redux
  if (!config.skipGlobalLoading) Store.dispatch(setPageLoading(true));
  return config;
}, (error) => {
  // Handle request error
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config?.skipGlobalLoading) Store.dispatch(setPageLoading(false));
    return Promise.resolve(response);
  },
  (error) => {
    if (!error.config?.skipGlobalLoading) Store.dispatch(setPageLoading(false));
    if (error !== null && error?.response?.status === 401) {
      window.localStorage.removeItem('accessToken');
      delete axiosInstance.defaults.headers.common.Authorization;
      window.localStorage.removeItem('user');
      clearActiveProvider();
      window.location.reload();
    }
    if (error !== null && error?.response?.status === 403) {
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong!');
  }
);

export default axiosInstance;
